import { render } from "./TitledSlider.vue?vue&type=template&id=24af5d2f"
import script from "./TitledSlider.vue?vue&type=script&lang=js"
export * from "./TitledSlider.vue?vue&type=script&lang=js"
script.render = render

export default script
import QSlider from 'quasar/src/components/slider/QSlider.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSlider});
